/**
 * External dependencies
 */
import classnames from 'classnames';

/**
 * WordPress dependencies.
 */
// import { InnerBlocks, RichText } from '@wordpress/block-editor';

/**
 * Inner dependencies.
 */
import BaseWrapper from '../../components/base-wrapper';
import { showRatingStar } from './helpers';

export default function save( props ) {
	const {
		className,
		attributes,
	} = props;
	const { textAlignment } = attributes;
	const wrapperClasses = classnames(
		className,
		`is-content-justification-${ textAlignment }`,
	);
	return (
		<div className={ wrapperClasses }>
			<BaseWrapper { ...props } name="gutenify/star-rating">
				{ showRatingStar( attributes ) }
			</BaseWrapper>
		</div>

	);
}

